// extracted by mini-css-extract-plugin
module.exports = {"root":"TourneyFooter_root__1BOYn","label":"TourneyFooter_label__2YrQc","select":"TourneyFooter_select__3XF7G"};